import { computed } from 'vue'
import { isEmpty } from 'global-utils'
import i18n from 'i18n'
import { useStore } from 'vuex'
import { useLogin } from '@/StoreWeb/js/composables/login-utils'

export function useContextBar () {
    const store = useStore()
    const { isAuthenticated } = useLogin()
    const headerBarZIndex = computed(() => store.state.headerBarZIndex)
    const isMobileApp = computed(() => store.state.isMobileApp)
    const selectedFareMedia = computed(() => store.state.userModule.selectedFareMedia)

    const getHasSelectedFareMedia = computed(() => {
        return selectedFareMedia.value && !isEmpty(selectedFareMedia.value) && selectedFareMedia.value.id !== undefined
    })
    const getTitle = computed(() => {
        return getHasSelectedFareMedia.value && !selectedFareMedia.value.isAccount ? selectedFareMedia.value.getTitle() : i18n.global.t('fare_media:context_bar:all_products:title')
    })
    const getSubtitle = computed(() => {
        if (getHasSelectedFareMedia.value && !selectedFareMedia.value.isAccount) {
            return selectedFareMedia.value.getSubtitle()
        }

        if (isMobileApp.value && isAuthenticated.value && !getHasSelectedFareMedia.value) {
            return 'Sélectionner ma carte'
        }

        return ''
    })

    return {
        headerBarZIndex,
        selectedFareMedia,
        getHasSelectedFareMedia,
        getTitle,
        getSubtitle
    }
}
